import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ task, currentColumn, nextColumn, range }) => {
    const after = range.min ? { uuid: range.min.uuid } : null;
    const reorder = () => repository.moveKanbanTask(task, after);
    const operation =
      task.status.uuid !== nextColumn.status.uuid
        ? repository
            .editTask(task, { ...task, status: nextColumn.status })
            .then(reorder)
        : reorder();

    return present(
      operation
        .then(() => ({ task, currentColumn, nextColumn, range }))
        .catch(() =>
          Promise.reject({ task, currentColumn, nextColumn, range }),
        ),
    );
  };
}

export type { Interactor };

export { createInteractor };
